// extracted by mini-css-extract-plugin
module.exports = {"tab":"xoZcnv_6","info":"__90t16cJh"};